import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserFormComponent } from './user-form.component';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from '../../material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { SelectSearchModule, FieldErrorMessagesModule } from '../../ui-kit';
import { DirectivesModule } from '../../common/directives/directives.module';

@NgModule({
  declarations: [UserFormComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MaterialModule,
    ReactiveFormsModule,
    SelectSearchModule,
    DirectivesModule,
    FieldErrorMessagesModule,
  ],
  exports: [UserFormComponent],
})
export class UserFormModule {}
